var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogout(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13 21C13 20.4477 12.5523 20 12 20L7 20C6.44771 20 6 19.5523 6 19L6 5C6 4.44772 6.44772 4 7 4L12 4C12.5523 4 13 3.55228 13 3C13 2.44772 12.5523 2 12 2L7 2C5.34315 2 4 3.34315 4 5L4 19C4 20.6569 5.34314 22 7 22L12 22C12.5523 22 13 21.5523 13 21Z",
    fill: "#181A1B"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11 12C11 11.4477 11.4477 11 12 11L17.865 11L15.8984 8.64016C15.5449 8.21588 15.6022 7.58532 16.0265 7.23175C16.4508 6.87819 17.0813 6.93551 17.4349 7.35979L20.7682 11.3598C21.0773 11.7306 21.0773 12.2693 20.7682 12.6402L17.4349 16.6402C17.0813 17.0644 16.4508 17.1218 16.0265 16.7682C15.6022 16.4146 15.5449 15.7841 15.8984 15.3598L17.865 13L12 13C11.4477 13 11 12.5523 11 12Z",
    fill: "#181A1B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogout);
export default __webpack_public_path__ + "static/media/logout.18b74e1758cf5ec6b4435a892e5146f8.svg";
export { ForwardRef as ReactComponent };